// 9fbef606107a605d69c0edbcd8029e5d 
import { COUNTRY_SELECTOR_ACTION_PATTERN } from '@tcp/core/src/constants/reducer.constants';

const COUNTRY_SELECTOR_CONSTANTS = {
  COUNTRY_SELECTOR_MODAL_TOGGLE: `${COUNTRY_SELECTOR_ACTION_PATTERN}COUNTRY_SELECTOR_MODAL_TOGGLE`,
  COUNTRY_SELECTOR_SUBMIT_DATA: `${COUNTRY_SELECTOR_ACTION_PATTERN}COUNTRY_SELECTOR_SUBMIT_DATA`,
  COUNTRY_SELECTOR_UPDATE_COUNTRY: `${COUNTRY_SELECTOR_ACTION_PATTERN}COUNTRY_SELECTOR_UPDATE_COUNTRY`,
  COUNTRY_SELECTOR_UPDATE_LANGUAGE: `${COUNTRY_SELECTOR_ACTION_PATTERN}COUNTRY_SELECTOR_UPDATE_LANGUAGE`,
  COUNTRY_SELECTOR_UPDATE_CURRENCY: `${COUNTRY_SELECTOR_ACTION_PATTERN}COUNTRY_SELECTOR_UPDATE_CURRENCY`,
  COUNTRY_SELECTOR_UPDATE_FLAG: `${COUNTRY_SELECTOR_ACTION_PATTERN}COUNTRY_SELECTOR_UPDATE_FLAG`,
  COUNTRY_SELECTOR_STORE_COUNTRIES_MAP: `${COUNTRY_SELECTOR_ACTION_PATTERN}COUNTRY_SELECTOR_STORE_COUNTRIES_MAP`,
  COUNTRY_SELECTOR_STORE_CURRENCIES_MAP: `${COUNTRY_SELECTOR_ACTION_PATTERN}COUNTRY_SELECTOR_STORE_CURRENCIES_MAP`,
  COUNTRY_SELECTOR_UPDATE_SITEID: `${COUNTRY_SELECTOR_ACTION_PATTERN}COUNTRY_SELECTOR_UPDATE_SITEID`,
};

export default COUNTRY_SELECTOR_CONSTANTS;
